module.exports = __webpack_public_path__ + "media/images/emblems/Locarno-coat_of_arms-d5105d805a859bb9dadbdad6967ed124.svg";